import colors from '../../../styles/colors';

class StatusLoteEnum {
  constructor() {
    this.CARREGANDO = 1;
    this.SUSPENSO = 2;
    this.ENCERRADO = 3;
    this.FINALIZADO = 4;
  }

  getTiposLabel() {
    return [
      {
        label: 'Carregando',
        value: this.CARREGANDO,
        active: true,
        background: colors.$brandcolor_primary_dark_green_12,
        textColor: colors.$brandcolor_primary_dark_green_11,
      },
      {
        label: 'Suspenso',
        value: this.SUSPENSO,
        active: true,
        background: colors.$auxiliary_yolk_4,
        textColor: colors.$auxiliary_yolk_3,
      },
      {
        label: 'Encerrado',
        value: this.ENCERRADO,
        active: false,
        background: colors.$auxiliary_berry_13,
        textColor: colors.$auxiliary_berry_12,
      },
      {
        label: 'Finalizado',
        value: this.FINALIZADO,
        active: true,
        background: colors.$auxiliary_berry_13,
        textColor: colors.$auxiliary_berry_12,
      },
    ];
  }

  getTipo(direcionamento) {
    return this.getTiposLabel()
      .filter(label => label.value === direcionamento)
      .shift();
  }
}

export default new StatusLoteEnum();
